import { createRoot } from "react-dom/client";
import { DataStateProvider } from "../context/dataState";
import { ModalStateProvider } from "../context/modalState";
import { UiStateProvider } from "../context/uiState";
import App from "../views/App";

const root = createRoot(document.querySelector("#app")!);
root.render(
  <UiStateProvider>
    <DataStateProvider>
      <ModalStateProvider>
        <App />
      </ModalStateProvider>
    </DataStateProvider>
  </UiStateProvider>,
);
